exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tableContainer {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  color: #F7F7F7;\n  border-collapse: collapse; }\n  .tableContainer tr {\n    height: 12vh;\n    font-size: 5vh; }\n  .tableContainer td {\n    height: 12vh;\n    padding-left: 10px;\n    padding-right: 10px;\n    vertical-align: middle;\n    padding-right: 20px;\n    font-size: 1.1em; }\n\n.tdIdenfify {\n  white-space: nowrap; }\n\n.statusDot {\n  margin-right: 30px; }\n\n.tdText {\n  padding-left: 20px !important;\n  font-weight: 600; }\n\n.colorStatus1 {\n  color: red; }\n\n.colorStatus2 {\n  color: green; }\n\n.colorStatus5 {\n  color: orange; }\n\n.noResult {\n  text-align: center;\n  font-size: 1em; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scss/Table.scss
// module id = 309
// module chunks = 0